import {useForm, FormProvider} from 'react-hook-form'
import {useHistory} from 'react-router-dom'

import {useTranslation} from '../../../../hooks/useTranslation'

import {CustomerTierSettingsDetails} from './components/CustomerTierSettingsDetails'
import {useCustomerTierSettingCreateMutation} from './hooks/useCustomerTierSettingsMutations'
import {useCustomerTierSettingsQuery} from './hooks/useCustomerTierSettingsQuery'
import {CustomerTierSettings} from './types/CustomerTierSettings'

const emptyFormState: CustomerTierSettings = {
  id: '',
  countryCode: '',
  businessLine: '',
  orgUnitId: '',
  dispatchGroup: null,
  tiers: [{name: 'A', percentage: 1, leadTimeInBusinessDays: null}]
}

export const CustomerTierSettingsCreate = () => {
  const history = useHistory()
  const customerTierSettingsMutation = useCustomerTierSettingCreateMutation()
  const {t} = useTranslation()

  const methods = useForm<CustomerTierSettings>({
    defaultValues: emptyFormState,
    mode: 'onChange'
  })

  const handleCreateButtonClick = async (data: CustomerTierSettings) => {
    try {
      await customerTierSettingsMutation.mutateAsync(data)
    } finally {
      history.goBack()
    }
  }

  const customerTierSettingsQuery = useCustomerTierSettingsQuery()

  if (customerTierSettingsQuery.isLoading || !customerTierSettingsQuery.data) {
    return (
      <div>{t('configurations.hconnect.customerTierSettings.configurationDetails.loading')}</div>
    )
  }

  return (
    <FormProvider {...methods}>
      <CustomerTierSettingsDetails
        mode="create"
        customerTierSetting={emptyFormState}
        onSaveButtonClick={methods.handleSubmit(handleCreateButtonClick)}
        isSubmitting={customerTierSettingsMutation.isLoading}
      />
    </FormProvider>
  )
}
